const TABS = [
  { title: "Today's Work Orders", day:'today' },
  { title: "Yesterday's Work Orders", day:'yesterday' },
]

export {TABS}